// extracted by mini-css-extract-plugin
export default {"option":"SelectOption_option__ko2pp","option__icon":"SelectOption_option__icon__0+I1F"};